// react
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// components
import { Videos } from './';

// ---
import { fetchFromAPI } from '../utils/fetchFromAPI';

const SearchFeed = () => {
  const [videos, setVideos] = useState([]);

  const { searchTerm } = useParams();

  useEffect(() => {
    setVideos([]);

    fetchFromAPI(`search?part=snippet&q=${searchTerm}`).then((data) => setVideos(data?.items));
  }, [searchTerm]);

  return (
    <section>
      <div className='w-full mt-4 mx-auto px-2.5'>
        <h2 className='text-3xl font-bold'>
          <span>Search results for: </span>
          <span className='text-red-600'>{searchTerm}</span>
        </h2>

        <Videos videos={videos} />
      </div>
    </section>
  );
};

export default SearchFeed;
